import { useParams } from "react-router-dom";
import ListState from "../../../../components/ListState/ListState";
import Loader from "../../../../shared-ui/Loader/Loader";
import { useGetLabRequest } from "../../hooks/e-prescribe.queries";
import { LabRequestStatuses } from "../../types/e-prescribe.types";
import CreateLabRequestForm from "../CreateLabRequestForm.tsx/CreateLabRequestForm";

export default function EditLabRequest() {
    const { labRequestId = "" } = useParams();
    const { data, error, isLoading } = useGetLabRequest(labRequestId);

    if (isLoading) {
        return <Loader />;
    }

    if (error || !data?.data) {
        return (
            <ListState
                isError
                context="general"
                errorMsg={
                    error?.response?.data.message ??
                    "Could not load this lab request"
                }
                stateHelperText="Return to the lab requests list and try again"
            />
        );
    }

    if (data.data.status === LabRequestStatuses.SIGNED) {
        return (
            <ListState
                isError
                context="general"
                errorMsg="Signed lab requests cannot be edited"
                stateHelperText="Return to the lab requests list to view this request"
            />
        );
    }

    return <CreateLabRequestForm labRequest={data.data} />;
}
